import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import backk from './images/backk.png'; // Make sure to provide the correct path to your image

function DisplayName() {
  const [personNames, setPersonNames] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetch('/DBRDAPI', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        SQL: 'SELECT DISTINCT PersonName FROM RosaF',
      }),
    })
    .then(response => response.json())
    .then(data => {
      if (data && data.length > 0) {
        setPersonNames(data);
      }
    })
    .catch(error => console.error('Error fetching person names:', error));
  }, []);

  const handleNameClick = (name) => {
    navigate(`/details/${name}`); // Navigate to the DetailedTime page with the selected person name
  };

  const handleBackClick = () => {
    navigate(-1); // Navigate back to the previous page
  };

  return (
    <div 
      style={{ 
        background: 'linear-gradient(to bottom, #fff7ad, #ffa9f9)', 
        minHeight: '100vh', 
        padding: '20px' 
      }}
    >
      <h2 style={{ color: '#E11584' }}>Person Names</h2>
      <ul>
        {personNames.map((name, index) => (
          <li 
            key={index} 
            onClick={() => handleNameClick(name)} 
            style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
          >
            {name}
          </li>
        ))}
      </ul>
      <button onClick={handleBackClick} style={{ marginTop: '20px' }}>
        <img src={backk} width="40" height="40" alt="Back" />
      </button>
    </div>
  );
}

export default DisplayName;
